import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ListarGrupoClientePage from "./gestionar-grupo-cliente/listar-grupo-cliente";
import GrupoClientePage from "./gestionar-grupo-cliente/grupo-cliente";
import ListarClientePage from "./gestionar-clientes/listar-cliente";
import ClientePage from "./gestionar-clientes/cliente";
import ListarTipoClientePage from "./gestionar-tipo-cliente/listar-tipo-cliente";
import TipoClientePage from "./gestionar-tipo-cliente/tipo-cliente";
import LayoutCliente from "../../components/layout-cliente";
import MapaClientePage from "./gestionar-clientes/mapa-cliente";
import ConfiguracionClientePage from "./configuracion-cliente/configuracion";

const RouterClientes = () => {
  const { path } = useRouteMatch();
  // console.log('RouterClientes');
  // console.log(path);
  return (
    // <LayoutClientes>
    <Switch>

      <Route exact path={`${path}/listar-grupo-cliente`}>
        <ListarGrupoClientePage />
      </Route>
      <Route exact path={`${path}/grupo-cliente`}>
        <GrupoClientePage />
      </Route>

      <Route exact path={`${path}/listar-tipo-cliente`}>
        <ListarTipoClientePage />
      </Route>
      <Route exact path={`${path}/tipo-cliente`}>
        <TipoClientePage />
      </Route>

      <LayoutCliente>
        <Route exact path={`${path}/listar-cliente`}>
          <ListarClientePage />
        </Route>
        <Route exact path={`${path}/mapa-cliente`}>
          <MapaClientePage />
        </Route>

        <Route exact path={`${path}/configuracion`}>
          <ConfiguracionClientePage />
        </Route>

        <Route exact path={`${path}/cliente`}>
          <ClientePage />
        </Route>
      </LayoutCliente>

    </Switch>
    // </LayoutAsignacion>
  );
};

export default RouterClientes;
